export enum ActionTypes {
  CancelAccountDiffRequest = 'cancelAccountDiff.request',
  CancelAccountDiffSuccess = 'cancelAccountDiff.success',
  CancelAccountDiffError = 'cancelAccountDiff.error',
}
